import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ProjectForm } from "Features/Projects";
import GuitarIcon from "Assets/SVG/GuitarIcon";

const New = () => {
    
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('newProject')} icon={<GuitarIcon />} includeBox>
            <ProjectForm onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default New
